import moment from 'jalali-moment';
import { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import tools from '../../utils/tools';
import { Sidebar } from '../Layout/Sidebar';

const Category = () => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 25;
  const endOffset = itemOffset + itemsPerPage;
  let currentItems = data.filter(e => e.title.toLowerCase().includes(query.toLowerCase())).slice(itemOffset, endOffset);
  const pageCount = Math.ceil(data.length / itemsPerPage);

  const deleteItem = async (id: number) => {
    if (confirm('آیا مطمئن هستید؟')) {
      dispatch(setLoading(true));

      const res = await restApi(endpoints.category.index + id).delete({});

      if (res.code == 204) {
        Swal.fire({
          title: 'موفق',
          text: 'دسته بندی با موفقیت حذف شد',
          icon: 'success',
          confirmButtonText: 'متوجه شدم',
          didClose() {
            fetchData();
          }
        });
      } else {
        Swal.fire({
          title: 'ناموفق',
          text: res?.data,
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        });
      }

      dispatch(setLoading(false));
    }
  };

  const syncToWooCommerce = async () => {
    const confirmSync = await Swal.fire({
      title: 'همگام‌سازی دسته‌بندی‌ها',
      text: 'آیا مطمئن هستید که می‌خواهید دسته‌بندی‌ها را با ورد پرس همگام‌سازی کنید؟',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'بله، همگام‌سازی کن',
      cancelButtonText: 'انصراف'
    });

    if (confirmSync.isConfirmed) {
      dispatch(setLoading(true));

      try {
        const syncRes = await restApi(process.env.REACT_APP_BASE_URL + '/admin/category/sync-to-woocommerce', true).post({});

        dispatch(setLoading(false));

        if (syncRes.code === 200) {
          const { created, updated, skipped, errors } = syncRes.data;
          Swal.fire({
            title: 'همگام‌سازی دسته‌بندی‌ها موفق',
            html: `
            <p>ایجاد شده: ${created}</p>
            <p>به‌روزرسانی شده: ${updated}</p>
            <p>رد شده: ${skipped}</p>
            <p>خطاها: ${errors.length}</p>
          `,
            icon: 'success',
            confirmButtonText: 'متوجه شدم'
          });
        } else {
          Swal.fire({
            title: 'خطا در همگام‌سازی',
            text: syncRes.data?.error || syncRes.data || 'خطایی رخ داده است',
            icon: 'error',
            confirmButtonText: 'متوجه شدم'
          });
        }
      } catch (error) {
        dispatch(setLoading(false));
        Swal.fire({
          title: 'خطا',
          text: 'خطایی رخ داده است',
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        });
      }
    }
  };

  const list = () => {
    const rows = [];

    currentItems.filter(e => e.title.toLowerCase().includes(query.toLowerCase())).map((category: any, index) => {
      rows.push(
        <tr
          className={`dashTr2 ${index % 2 === 0 ? 'table-row-even' : 'table-row-odd'}`}
          key={`category-${category.id}-${index}`}
        >
          <td className="svgContainer">
            <i className="eye"></i>
            <i className="trash clickable" onClick={() => deleteItem(category.id)}></i>
            <i className="edit clickable" onClick={() => navigate('/category/edit/' + category.id)}></i>
          </td>
          <td className="">{moment(category.createdAt).format('jYYYY/jMM/jDD HH:MM')}</td>
          <td className="">{category.description}</td>
          <td className="">{category.slug}</td>
          <td className="">{category.parent?.title || '-'}</td>
          <td className="">{category.title}</td>
          <td>{index + 1}</td>
        </tr>
      );
    });

    return rows;
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.category.index, true).get({ type: 'children' });

    const res2 = await restApi(endpoints.category.old).get();

    const sortedData = [];

    res.data.map(e => tools.extractChildren(e, sortedData));

    if (res.code == 200) {
      setData(sortedData);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <main className="dashboardBody">
        <Sidebar/>
        <div className="dashBoardMain">
          <h1 className="dashBoardTitle">لیست دسته بندی ها</h1>
          <div className="searchContainer">
            <div className="keepRight svgContainer">
              <span className="dashboardHeader clickable" onClick={() => navigate('/category/add')}>
                <p>افزودن دسته بندی  جدید</p>
                <i className="addPlus"></i>
              </span>
              <span className="dashboardHeader clickable" onClick={syncToWooCommerce}>
                <p>همگام‌سازی با ورد پرس</p>
                <i className="addPlus"></i>
              </span>
            </div>
            <div className="dashboardseaechBox">
              <i className="dashMagnifierIcon"></i>
              <input className="dashSearchInput" placeholder="جستجو" onChange={(input: any) => setQuery(input.target.value)}></input>
            </div>
          </div>
          <table className="alternating-table listTable">
            <thead>
            <tr className="dashTr1 firstTr">
              <th>عملیات</th>
              <th>تاریخ ساخت</th>
              <th>توضیحات</th>
              <th>اسلاگ</th>
              <th>والد</th>
              <th>عنوان</th>
              <th>ردیف</th>
            </tr>
            </thead>
            <tbody>
            {list()}
            </tbody>
          </table>
          <ReactPaginate
            breakLabel="..."
            nextLabel="بعدی >"
            onPageChange={(event) => setItemOffset((event.selected * itemsPerPage) % data.length)}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="< قبلی"
            renderOnZeroPageCount={null}
            className="pagination"
            pageClassName="paginationBreak"
            previousClassName="paginationBreak"
            nextClassName="paginationBreak"
            activeClassName="paginationActive"
          />
        </div>
      </main>
    </>
  );
};
export default Category;